export default "__VITE_ASSET__8d87147b__"